export default (n = 0) => {
  if (n == 0) return "";
  if (n == 1) return "level-1";
  if (n == 2) return "level-2";
  if (n == 3) return "level-3";
  if (n == 4) return "level-4";
  if (n == 5) return "level-5";
  return "";
};
